module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-desktop@2x-5943ee37aac73dbc3fda0557bc21208f.jpg";